import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-authentication-error',
  templateUrl: './authentication-error.component.html'
})
export class AuthenticationErrorComponent implements OnInit {

  public error: any;

  constructor(private authService: AuthService) {
  }

  ngOnInit() {
    this.error = this.authService.lastAuthentictionError;
  }

}
